import classNames from 'clsx';
import React from 'react';

import styles from './Balance.scss';

export enum Type {
  Chest = 'chest',
  TournamentMoney = 'tournament-money'
}

export interface Props {
  balance: React.ReactNode;
  className?: string;
  type: Type;
}

const Balance: React.FC<Props> = (props) => (
  <div className={classNames(styles.balance, styles[props.type], props.className)}>
    {props.balance}
  </div>
);

export default Balance;
